import React, { Component } from "react";
import "./style.scss";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import Heading from "../../elements/heading";

export default class Notice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true
    };
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.setState({ visible: false });
  }

  notice(fields, className) {
    const { paddingAboveTop, paddingAboveBottom, gridType, backgroundColor, alignment, overline, headingBody, headingType, body, otherClass } = fields;
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "default",
      grid = gridType ? gridType.fields.phrase.value : "normal",
      gridClass = grid === "story" ? "grid-story" : grid === "normal" ? "grid" : grid === "full-width" ? "full-width" : "grid";
    const noticeClasses = classNames("notice", className, "padding-top-" + top, "padding-bottom-" + bottom, gridClass);

    let backgroundStyle = {};
    backgroundStyle = {
      background: backgroundColor ? backgroundColor.fields.phrase.value : ""
    };
    const contentClasses = classNames("content", alignment ? alignment.fields.phrase.value : "", otherClass ? otherClass.value : '');
    return (
      <div className={noticeClasses} style={backgroundStyle} datasourceid={this.props?.rendering?.dataSource}>
        <button className="notice-close" onClick={this.handleClose} aria-label="Close notice">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L13 13M1 13L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
        <div className={contentClasses}>
          {overline && <p className="overline">{overline.value}</p>}
          {headingBody && (
            <Heading
              {...{
                html: headingBody,
                type: headingType
              }}
              className={"title"}
            />
          )}
          {body && <RichText tag="div" className={"body-text"} field={body} />}
        </div>
      </div>
    );
  }

  documentChange(fields) {
    let { headingBody, body } = fields;
    if (headingBody) {
      let node = document.createElement("div");
      node.innerHTML = headingBody.value;

      if (node.firstChild && node.firstChild.className === "") {
        node.firstChild.className = "type-h1";
        headingBody.value = node.innerHTML;
      }
    }

    // set default heading style if non is set from the RTF in sitecore
    if (body) {
      let node2 = document.createElement("div");
      node2.innerHTML = body.value;

      let resultNode = document.createElement("div");

      let array = Array.from(node2.children);
      array.forEach(element => {
        if (element && element.firstChild) {
          if (element.nodeName === "H1" && element.firstChild.className === "") {
            element.firstChild.className = "type-h1";
          } else if (element.nodeName === "H2" && element.firstChild.className === "") {
            element.firstChild.className = "type-h2";
          } else if (element.nodeName === "H3" && element.firstChild.className === "") {
            element.firstChild.className = "type-h3";
          } else if (element.nodeName === "H4" && element.firstChild.className === "") {
            element.firstChild.className = "type-h4";
          }
        }
        resultNode.appendChild(element);
      });

      body.value = resultNode.innerHTML;
    }
  }
  componentDidMount(props) {
    const { fields } = this.props;
    this.documentChange(fields);
  }

  render() {
    if (!this.props.fields) return null;
    if (!this.state.visible) return null;
    const { fields, className } = this.props;
    const { gridType } = fields;
    if ((gridType && gridType.fields.phrase.value) === "story") {
      return <div className={"grid"}>{this.notice(fields, className)}</div>;
    } else {
      return this.notice(fields, className);
    }
  }
}
